export default __webpack_public_path__ + "static/media/barmarche1.2d65ce40.png";